import { type ActorRefFromLogic } from "xstate";

import { getGiteaApiUrl } from "~/utils/gitea";

import { type AuthenticationMachine, waitForAccessTokenSilently } from "../authentication";

export const remoteDocumentRepoExistsPromise = async ({
	input,
}: {
	input: {
		documentId: string;
		publishWorkspace: string | unknown;
		authenticationActorRef: ActorRefFromLogic<AuthenticationMachine>;
	};
}): Promise<boolean> => {
	const { documentId, publishWorkspace, authenticationActorRef } = input;
	if (!publishWorkspace) {
		return false;
	}

	const token = await waitForAccessTokenSilently(authenticationActorRef);
	if (!token) {
		throw new Error("Not authenticated");
	}

	let response: Response | undefined;
	try {
		response = await fetch(
			`${getGiteaApiUrl()}/api/v1/repos/${publishWorkspace}/${documentId}`,
			{ headers: { Authorization: "Bearer " + token } }
		);
	} catch (e) {
		if (e instanceof Error && e.message === "Not found") {
			return false;
		}
		throw e;
	}

	return response.ok;
};
